import { firestore, functions, storage } from 'firebaseSDK';
import { noticeDefault } from 'config/dataDefaults';
import { Timestamp } from 'firebase/firestore';
import { getDownloadURL, uploadString } from 'firebase/storage';
import { v4 as uuidv4 } from 'uuid';
import { picturesMaxSize } from '../../config';
import resizeImageFile from '../../helpers/resizeImageFile';
import Actions from './abstract/Actions';

class NoticesActions extends Actions {
  markAsViewed(notices) {
    const noticesArray = Array.isArray(notices) ? notices : [notices];

    return Promise.all(
      noticesArray.map((noticeDoc) =>
        firestore.markNoticeAsViewed(noticeDoc.id)
      )
    );
  }

  preSubmitMessage_() {
    const { profile } = this.root.userDataState;
    const messageData = noticeDefault();
    const nowDate = Timestamp.fromDate(new Date());

    messageData.noticeUid = uuidv4().toUpperCase();
    messageData.dateCreated = nowDate;
    messageData.dateUpdated = nowDate;

    messageData.messageFromName = profile.data.firstName;
    messageData.messageFromUid = profile.data.profileUid;

    return messageData;
  }

  sendMessage(tenancyUid, messageText, messageTitle) {
    const messageData = this.preSubmitMessage_();
    messageData.noticeTitle = messageTitle;
    messageData.tenancyUid = tenancyUid;
    messageData.messageText = messageText;

    console.log(messageData);

    return functions.tenancy.sendMessage(messageData);
  }

  async sendFile(tenancyUid, file, messageTitle) {
    const messageData = this.preSubmitMessage_();
    messageData.noticeTitle = messageTitle;
    messageData.tenancyUid = tenancyUid;
    messageData.isImage = true;

    const base64image = await resizeImageFile(
      file,
      picturesMaxSize.message,
      picturesMaxSize.message
    );

    const ref = storage.getMessageImage(
      messageData.tenancyUid,
      messageData.noticeUid
    );

    messageData.messageText = await uploadString(
      ref,
      base64image,
      'data_url'
    ).then(() => getDownloadURL(ref));

    return functions.tenancy.sendMessage(messageData);
  }
}

export default NoticesActions;
